import { Provider } from "@angular/core";
import type { WkDataTableColumnRegistration } from "@components/data-table/data-table.types";
import { getWkDataTableColumnRegistry } from "@components/data-table/data-table.tokens";

export function provideWkDataTableColumn<T extends WkDataTableColumnRegistration = WkDataTableColumnRegistration>(registration: T): Provider[] {
    return [
        registration.service,
        {
            provide: getWkDataTableColumnRegistry<T>(),
            multi: true,
            useValue: registration,
        },
    ];
}
